import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

export async function getFrameFft(upload_id, timeVal) {
  if (!upload_id || timeVal === undefined || timeVal === null) {
    return {
      success: false,
      data: null,
      ...normalizeApiMessage(
        { message: "upload_id and time are required." },
        "upload_id and time are required.",
      ),
    };
  }

  try {
    const qs = new URLSearchParams();
    qs.set("upload_id", String(upload_id));
    qs.set("time", String(timeVal));

    const path = `${BACKEND_URL}/project/frame_fft?${qs.toString()}`;

    const res = await authFetch(
      path,
      { method: "GET" },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    const result = await res.json().catch(() => null);

    if (!result) {
      return {
        success: false,
        data: null,
        ...normalizeApiMessage(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
        ),
        messageKey: "api.common.serverError",
      };
    }

    if (!res.ok) {
      if (res.status === 401) {
        return {
          success: false,
          data: null,
          ...normalizeApiMessage(
            result,
            "Session expired. Please sign in again.",
          ),
          messageKey:
            result?.messageKey || result?.message_key || "api.auth.token.expired",
        };
      }

      return {
        success: Boolean(result.success),
        data: result.data ?? null,
        ...normalizeApiMessage(result, "Request failed."),
      };
    }

    return {
      success: result.success ?? true,
      data: result.data ?? null,
      ...normalizeApiMessage(result, "Data loaded successfully."),
    };
  } catch (error) {
    console.error("getFrameFft request failed:", error);
    return {
      success: false,
      data: null,
      ...normalizeApiMessage(
        { message: "Server request failed." },
        "Server request failed.",
      ),
      messageKey: "api.common.networkError",
    };
  }
}
